// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","242":"project","443":"about"}[chunkId] + "." + {"18":"aa922d01","242":"ef85d7b7","443":"2421cacc"}[chunkId] + ".js";
};